import React from 'react';
import { BowMark } from './BowMark';
import { BRAND, SUPPORT_EMAIL } from '../data/collection';
export function Footer() {
  return <footer id="site-footer" className="w-full bg-graphite-deep text-ivory" data-id="element-55" data-mp="3ggtz0kj4bn6a">
      <div className="mx-auto max-w-6xl px-5 pb-28 pt-12 sm:px-8 md:pb-12" data-id="element-56" data-mp="32ovwwtntqrjm">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-57" data-mp="36oxzr65apr0h">
          <div data-id="element-58" data-mp="3ufa5qbgzddof">
            <p className="flex items-center gap-2" data-id="element-59" data-mp="3uesani6215i3">
              <BowMark className="h-6 w-9" data-id="element-60" data-mp="3ucxmluzhkx9s" />
              <span className="font-serif text-[1.35rem] font-semibold italic" data-id="element-61" data-mp="38z8yrj06z2w">{BRAND.name}</span>
            </p>
            <p className="mt-2 text-[0.98rem] text-ivory/75" data-id="element-62" data-mp="3ldaobi2207ky">{BRAND.name} · Creativo Digital</p>
          </div>
          <div className="text-[0.98rem]" data-id="element-63" data-mp="3qc445h4tcaoa">
            <p className="font-bold" data-id="element-64" data-mp="29z6t68jqcdeb">Contacto</p>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-1 inline-flex min-h-[48px] items-center break-all text-ivory/85 underline decoration-ivory/30 underline-offset-4 hover:text-white hover:decoration-coral focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/50" data-id="element-65" data-mp="29ydvry6nv08u">
              {SUPPORT_EMAIL}
            </a>
          </div>
        </div>
        <div className="mt-8 border-t border-white/10 pt-6 text-[0.9rem] leading-relaxed text-ivory/70" data-id="element-66" data-mp="3v8hou08iooow">
          <p data-id="element-67" data-mp="3q724ybi2so83">Archivos digitales para uso personal y confección de prendas para vender. No redistribuir ni revender los PDF.</p>
          <p className="mt-2" data-id="element-68" data-mp="80xmgfnmfdms">© 2026 {BRAND.name} · Creativo Digital</p>
        </div>
      </div>
    </footer>;
}